module.exports = __webpack_public_path__ + "static/media/aria_thumb_even.6591883c.jpg";